import { render, staticRenderFns } from "./person_demographics.vue?vue&type=template&id=50afd868&"
import script from "./person_demographics.vue?vue&type=script&lang=js&"
export * from "./person_demographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50afd868')) {
      api.createRecord('50afd868', component.options)
    } else {
      api.reload('50afd868', component.options)
    }
    module.hot.accept("./person_demographics.vue?vue&type=template&id=50afd868&", function () {
      api.rerender('50afd868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/person_demographics.vue"
export default component.exports